import {
  rtmpDestinationV2EntityRaw,
  RtmpDestinationV2EntityRaw
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseResponseDTO } from "@youm-front/common/domain";

export class RtmpDestinationsListResponseDTO extends BaseResponseDTO<RtmpDestinationsListResponseDTORaw> {
  private static validateFunction = JsonSchemaValidator.compile(
    RtmpDestinationsListResponseDTO.validationSchema()
  );

  constructor(value: RtmpDestinationsListResponseDTORaw) {
    super(
      JsonSchemaValidator.assert(
        RtmpDestinationsListResponseDTO.validateFunction,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["destinations"],
      properties: {
        destinations: {
          type: "array",
          items: rtmpDestinationV2EntityRaw
        }
      },
      additionalProperties: false
    };
  }
}

interface RtmpDestinationsListResponseDTORaw {
  destinations: RtmpDestinationV2EntityRaw[];
}
